import React, { useState, useEffect,useContext } from "react";
import { Parser } from "expr-eval";
import { AppContext } from "../AppContext/AppContext";
import { sub } from "date-fns";


const ProductForm = ({ product,handleSingleExtra,existsInOrder=false }) => {
  let context = useContext(AppContext);
      if(Object.keys(context).length === 0){
          if(sessionStorage.hasOwnProperty('session')){
            context = JSON.parse(sessionStorage.getItem('session'));
          }
      }
  const { form, priceFormula, basePrice } = product;
  const height = 40;

  const nights = (date_1, date_2) =>{
        date_1 = typeof(date_1) === 'string' ? new Date(date_1) : date_1 ;
        date_2 = typeof(date_2) === 'string' ? new Date(date_2) : date_2 ;
        let difference = date_1.getTime() - date_2.getTime();
        let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
        return TotalDays;
    }

  // Initialize form values
  const initialValues = form.reduce((acc, field) => {
    acc[field.key] = field.default ?? 1;

  if(!!existsInOrder){
    console.log(product.id,field,existsInOrder );
    if (existsInOrder["userInput"].hasOwnProperty(field.key)) {
      // alert(existsInOrder["userInput"][field.key])
      acc[field.key] = existsInOrder["userInput"][field.key];
    }
  }
    if(field.field === "nights" && context && context.from && context.to){
        acc[field.key] = nights(context.to,context.from);
    } 
        
    return acc;
  }, {});

  const [formValues, setFormValues] = useState(initialValues);
  const [price, setPrice] = useState(0);

  // Handle manual typing in input
  const handleChange = (key, value) => {
    const numericValue = value === "" ? 1 : Number(value);
    setFormValues((prev) => ({ ...prev, [key]: numericValue }));
  };

  const getFormValues = () => {
    return formValues;
  };

  // Handle +/- buttons
  const adjustValue = (key, step) => {
    setFormValues((prev) => {
      const current = prev[key] ?? 1;
      const min = form.find((f) => f.key === key)?.min ?? 1;
      const next = current + step;
      return { ...prev, [key]: next < min ? min : next };
    });
  };

  const submitExtraDetails=()=>{
        //submit extra details to parent component
            const userInput = getFormValues();
            console.log('Extra Details:', userInput);
            // this.props.handleExtraDetails(extraDetails);
            handleSingleExtra(product,userInput);
  }

  const removeExtraDetails=()=>{
    //submit extra details to parent component
            const userInput = getFormValues();
            console.log('Extra Details:', userInput);
            // this.props.handleExtraDetails(extraDetails);
            handleSingleExtra(product,userInput,'remove');
    }
  // Calculate price whenever inputs change
  useEffect(() => {
    try {
    const parser = new Parser();
    const expr = parser.parse(priceFormula);

    const variables = { ...formValues, basePrice };
      const result = expr.evaluate(variables);
      setPrice(result);
    } catch {
      setPrice(0);
    }
  }, [formValues, priceFormula, basePrice]);

  return (
    <div style={{ maxWidth: 400 }}>

      <div id="rate-value" className="">
                          <div className="medium">From</div>
                          <div id="value">{product.currency} {price} </div>
                          <small>Excluding Taxes &amp; Fees</small>
                        </div>
                        <br />

      {form.map((field) => (
        <div key={field.key} style={{ marginBottom: 15 }}>
          {console.log(field)}
          <label style={{ display: "block", marginBottom: 5 }}>
            {field.label}:
          </label>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            {field.input_by === "user" ? 
            <button
              type="button"
              onClick={() => {
                adjustValue(field.key, -1)
              }}
              className ="qty"
              style={{
                padding: "6px 10px",
                borderRadius: "6px",
                cursor: "pointer",
                height: height
              }}
            >
              –
            </button>
            :""}

            <input
              type={field.type || "number"}
              value={formValues[field.key]}
              min={field.min || 0}
              max={field.max || undefined}
              onChange={(e) => handleChange(field.key, e.target.value)}
              className ="qty"
              style={{
                width: 80,
                textAlign: "center",
                padding: "6px",
                borderRadius: "6px",
                marginBottom: 0,
                height: height
              }}
              disabled={field.input_by !== "user"}
            />

            {field.input_by === "user" ? 

            <button
              type="button"
              onClick={() => {
                adjustValue(field.key, 1)
              }}
              style={{
                padding: "6px 10px",
                borderRadius: "6px",
                cursor: "pointer",
                height: height
              }}
              className ="qty"
            >
              +
            </button>
            :""}

          </div>
        </div>
      ))}
              <button
                type="button"
                className="btn-book"
                onClick={()=>{
                  submitExtraDetails();
                }}
              >
                {!existsInOrder ? `Add to Reservation` : `Update Details`}
              </button>
              {existsInOrder ?  
              <div className="link"><u onClick={()=>{removeExtraDetails()}}>Remove from Cart</u></div>
              : ``}
    </div>
  );
};

export default ProductForm;
